export const reducers = {
  resetMintingState: (state) => {
    state.isMintingInProgress = false;
    state.isMintingComplete = false;
    state.isMintingRejected = false;
    state.tokenId = null;
  },
};
